/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'financialStatements': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M0 0h20v20H0z"/><path pid="1" d="M2.853 18C2 18 2 17.483 2 16.265V3.063C2 2.476 2.295 2 2.853 2c.557 0 .687.475.687 1.063v13.396h13.45c.558 0 1.01.193 1.01.78s-.452.761-1.01.761H2.853h.001zm11.51-2.286v-5.333h1.455v5.333h-1.454zm-4.363 0V8.095h1.455v7.62H10zm-4.364 0V9.62h1.455v6.095H5.636zM9.626 3.82L6.143 7.256c-.742.678-1.685-.448-.992-1.117l3.934-3.923a.981.981 0 01.763-.204c.27.042.513.197.673.43l3.358 3.626 1.3-1.794c.56-.78 1.683-.058 1.282.729l-1.958 2.694c-.18.283-.384.375-.709.398-.302 0-.485-.177-.663-.398L9.626 3.819z" _fill="currentColor" fill-rule="nonzero"/></g>'
  }
})
